<template>
  <section id="infoVinaigre" class="columns">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/o-fil-des-saisons.appspot.com/o/marmiton1.jpg?alt=media&token=a261daa1-91f1-4b4f-b20e-037844a1434e"
      alt="O' Fil des saisons"
      class="column is-6"
    />
    <img
      src="https://firebasestorage.googleapis.com/v0/b/o-fil-des-saisons.appspot.com/o/marmiton2.jpg?alt=media&token=7526219d-f4ba-4d18-9b45-a4db8d1f7846"
      alt="O' Fil des saisons"
      class="column is-6"
    />
  </section>
</template>

<script>
export default {
  name: "DetailInfo",
};
</script>


<style lang="sass">
.limit-space-image
  flex: 1!important
  flex-shrink: 1!important
.contain
  object-fit: contain !important
</style>
